const TRANSFORMATION_DRAWERS = {
  PIPELINE_EVENT_SPLIT: 'PIPELINE_EVENT_SPLIT',
  PIPELINE_FILTERS: 'PIPELINE_FILTERS',
  PIPELINE_TRANSFORMS: 'PIPELINE_TRANSFORMS',
};

export default TRANSFORMATION_DRAWERS;
